import { Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

import { useUserRole } from '@/hooks/useUserRole';

export const ViewSwitcher = () => {
  const { isAdmin, isAdvisor } = useUserRole();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  if (!isAdmin || !isAdvisor) return null;

  const inAdmin = pathname.startsWith('/admin');

  return (
    <Button
      fullWidth
      disableElevation
      variant={inAdmin ? 'contained' : 'outlined'}
      onClick={() => navigate(inAdmin ? '/dashboard' : '/admin')}
      sx={{
        padding: '9px 12px',
        borderRadius: '8px',
        fontSize: 13,
        fontWeight: 600,
        fontFamily: 'Manrope, sans-serif',
        letterSpacing: '-0.01em',
        textTransform: 'none',
        transition: 'opacity 0.15s',
        ...(inAdmin
          ? {
              background: 'var(--tx-fill-2)',
              color: 'var(--tx-text)',
              border: 0,
              '&:hover': { background: 'var(--tx-fill-2)', opacity: 0.8 },
            }
          : {
              background: 'var(--tx-fill)',
              color: 'var(--tx-muted)',
              border: 0,
              '&:hover': { background: 'var(--tx-fill-2)' },
            }),
      }}>
      {inAdmin ? 'Switch to Advisor' : 'Switch to Admin'}
    </Button>
  );
};
